export default __webpack_public_path__ + "static/media/regionSelected.0c8082e7.svg";